import { c as _c } from "react/compiler-runtime";
import WaveSettingEditorActions from "./WaveSettingEditorActions";
interface WaveDisableLinksEditorFormProps {
  readonly checked: boolean;
  readonly disabled: boolean;
  readonly onCancel: () => void;
  readonly onCheckedChange: (checked: boolean) => void;
  readonly onSave: () => void;
}
export default function WaveDisableLinksEditorForm(t0) {
  const $ = _c(18);
  const {
    checked,
    disabled,
    onCancel,
    onCheckedChange,
    onSave
  } = t0;
  let t1;
  if ($[0] !== onSave) {
    t1 = event => {
      event.preventDefault();
      onSave();
    };
    $[0] = onSave;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onCheckedChange) {
    t2 = event_0 => onCheckedChange(event_0.target.checked);
    $[2] = onCheckedChange;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== checked || $[5] !== disabled || $[6] !== t2) {
    t3 = <input type="checkbox" aria-label="Disable links" autoFocus={true} checked={checked} disabled={disabled} onChange={t2} className="tw-mt-0.5 tw-h-4 tw-w-4 tw-rounded tw-border-iron-600 tw-bg-iron-900 tw-text-primary-500 focus:tw-ring-primary-400 disabled:tw-cursor-not-allowed disabled:tw-opacity-50" />;
    $[4] = checked;
    $[5] = disabled;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span>Disable links</span>;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3) {
    t5 = <label className="tw-flex tw-cursor-pointer tw-items-start tw-gap-2 tw-text-sm tw-text-iron-100">{t3}{t4}</label>;
    $[9] = t3;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== disabled || $[12] !== onCancel) {
    t6 = <WaveSettingEditorActions disabled={disabled} onCancel={onCancel} />;
    $[11] = disabled;
    $[12] = onCancel;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t1 || $[15] !== t5 || $[16] !== t6) {
    t7 = <form className="tw-flex tw-flex-col tw-gap-3" onSubmit={t1}>{t5}{t6}</form>;
    $[14] = t1;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}